import { useRemoteUsers } from 'agora-rtc-react';
import { useEffect, useRef } from 'react';

const STOP_FEATURE_DELAY = 180000; // 3 minutes in milliseconds

export interface CallFeature {
  isActive: boolean;
  start(): void;
  stop(): void;
}

export default function useAutoCallFeature(
  { joined, isEnabled }: { joined: boolean; isEnabled: boolean },
  feature: CallFeature,
) {
  const remoteUsers = useRemoteUsers();
  const stopTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!joined || !isEnabled || !feature.isActive) {
      return;
    }
    if (remoteUsers.length === 0) {
      stopTimeoutRef.current = setTimeout(() => {
        feature.stop();
      }, STOP_FEATURE_DELAY);
    } else {
      if (stopTimeoutRef.current) {
        clearTimeout(stopTimeoutRef.current);
        stopTimeoutRef.current = null;
      }
    }

    return () => {
      if (stopTimeoutRef.current) {
        clearTimeout(stopTimeoutRef.current);
      }
    };
  }, [joined, isEnabled, feature, remoteUsers.length]);

  useEffect(function triggerFeature() {
    if (!isEnabled) return;
    if (joined) {
      if (remoteUsers.length && !feature.isActive) {
        feature.start();
      }
    } else {
      feature.stop();
    }
  }, [joined, isEnabled, feature, remoteUsers.length]);
}
